import HeroSection from './sections/HeroSection';
import AboutSection from './sections/AboutSection';
import ProductsSection from './sections/ProductsSection';
import OpenSourceSection from './sections/OpenSourceSection';
import ServicesSection from './sections/ServicesSection';
import DocsSection from './sections/DocsSection';
import CommunitySection from './sections/CommunitySection';
import ContactSection from './sections/ContactSection';
import TeamMapSection from './sections/TeamMapSection';

export default function HomePage({ theme }) {
  return (
    <main>
      <HeroSection theme={theme} />
      <AboutSection />
      <ProductsSection />
      <OpenSourceSection />
      <ServicesSection />
      <DocsSection />
      <CommunitySection />
      <TeamMapSection />
      <ContactSection />
    </main>
  );
}
